import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
    return (
        <div className="splash-img">
        </div>
    )
}

export default SplashScreen;